import events from './events';
import surveyMethods from './surveyMethods';

const survey = {
  ...events,
  ...surveyMethods
};

export function enableSurveyAPI() {
  window.survey = survey;
  window.MedalliaSurvey = survey;
}

export default survey;
